import { foundationTooltipStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroTooltipStyles = (context, definition) => css `
  ${foundationTooltipStyles(context, definition)}
`;
